import React from "react";
import { Container, Button } from "react-bootstrap";
import { useNavigate } from "react-router-dom";

function SupportPage() {
  const navigate = useNavigate();

  return (
    <Container className="mt-4 text-center">
      <h1 className="mb-4 fade-in">Support This App</h1>

      <p className="lead fade-in" style={{ color: "#fff", opacity: 0.9 }}>
        If this prayer app has blessed you, consider supporting its continued
        development. Your support helps keep the app free, ad‑free, and growing
        with more prayers and languages.
      </p>

      {/* Example Support Button (replace with your real link later) */}
      <Button
        className="glass-button bg-transparent border-0 mt-3"
        onClick={() => window.open("https://buymeacoffee.com/prayersinsilence", "_blank")}
      >
        ❤️ Support / Donate
      </Button>

      <div className="mt-4">
        <Button
          className="glass-button bg-transparent border-0"
          onClick={() => navigate("/")}
        >
          Home
        </Button>
      </div>
    </Container>
  );
}

export default SupportPage;
